import { appstr } from "./appstr";

export function Cappstr(strCode) {
  return appstr(strCode).toUpperCase();
}
